/// <amd-module name="DistributedTaskUI/Resources/ResourcesSource" />
import { CheckIssueData } from "Checks/Client/Contracts/PipelinesChecks";
import { ResourceFilters, ResourcesHubData } from "DistributedTask/Client/Contracts/TaskAgent";
import * as Constants from "DistributedTaskUI/Resources/Constants";
import { getTFSPageData } from "Tfs/Platform/Page";
import { IIdentity, IVssIdentityService, VssIdentityServiceName } from "VSS/Features/Identities/IdentityService";
import { IVssPageContext } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";

export class ResourcesSource {
    constructor(
        private _pageContext: IVssPageContext
    ) {
        this._identityService = this._pageContext.getService<IVssIdentityService>(VssIdentityServiceName);
        this._contributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
        const tfsPageData = getTFSPageData(this._pageContext);
        if (tfsPageData && tfsPageData.project) {
            this._projectId = tfsPageData.project.id;
        }
    }

    public initialize(ignoreCache: boolean): Promise<ResourcesHubData> {
        return this._contributionService.getDataAsync<ResourcesHubData>("ms.vss-distributed-task.resources-hub-core-data-provider", null, ignoreCache);
    }

    public saveSettings(value: ResourceFilters): void {
        const storageKey: string = "Resources/Filters/" + this._projectId;
        this._pageContext.getService<ISettingsService>("ISettingsService").setEntries({ [ storageKey ]: value }, SettingsUserScope.Me);
    }

    public getResourcesFeatureFlag(featureFlagName: string): boolean {
        return isFeatureFlagEnabled(
            this._pageContext,
            featureFlagName,
            false
        );
    }

    public getResourcesCheckIssues(resourceParams: { [key: string]: string; }): Promise<CheckIssueData> {
        return this._contributionService.getDataAsync<CheckIssueData>(Constants.CheckIssuesDataProviderContribution, resourceParams);
    }

    public getResources(filters: ResourceFilters, continuationToken?: string): Promise<ResourcesHubData> {
        const parameters: { [key: string]: ResourceFilters | string } = {};
        parameters["resourceFilters"] = filters;
        parameters["continuationToken"] = continuationToken;

        return this._contributionService.getDataAsync<ResourcesHubData>("ms.vss-distributed-task.resources-hub-query-data-provider", parameters, true)
            .then((data: ResourcesHubData) => {
                if (!data) {
                    return null;
                }

                return data;
            }, (error: Error) => {
                throw error;
            });
    }

    private _toIdentityRef(identity?: IIdentity): IdentityRef | undefined {
        if (!identity || !identity.subjectDescriptor) {
            return undefined;
        }

        return {
            descriptor: identity.subjectDescriptor,
            id: identity.localId || identity.originId,
            displayName: identity.displayName,
            uniqueName: identity.samAccountName ? `${identity.scopeName}\\${identity.samAccountName}` : identity.signInAddress || identity.mail,
            imageUrl: identity.image,
            _links: {
                avatar: {
                    href: identity.image
                }
            }
        } as IdentityRef;
    }

    private _identityService: IVssIdentityService;
    private _contributionService: IVssContributionService;
    private _projectId: string;
}
